import { useQuery } from "@tanstack/react-query";
import { PalletService } from "src/services/pallets";
import { queryKeys } from "src/constants";

const useCompletePallets = (palletService: PalletService) => {
  const {
    data: completePalletsData,
    isLoading,
    error: fetchError,
    refetch: refreshCompletePallets
  } = useQuery({
    queryKey: queryKeys.completePallets(),
    queryFn: () => palletService.getCompletePallets({ limit: 500 })
  });

  return {
    completePallets: completePalletsData?.items ?? [],
    isLoading,
    fetchError,
    refreshCompletePallets
  };
};

export { useCompletePallets };
